import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Bell, BellOff, Volume2 } from "lucide-react";
import { alertsEnabled, setAlertsEnabled, requestNotifPermission, handleNotificationsBatch, detectProdShipEvents, detectProductionCompleted, playDing } from "@/lib/alerts";

const POLL_MS = 30000; // 30 saniye

export default function AlertPoller() {
  const [enabled, setEnabled] = useState(alertsEnabled());
  const [notifPerm, setNotifPerm] = useState(typeof Notification !== "undefined" ? Notification.permission : "unsupported");
  const prodListRef = useRef([]);

  useEffect(() => {
    let stopped = false;
    const tick = async () => {
      if (stopped || !alertsEnabled()) return;
      try {
        const [notifs, prods, ships] = await Promise.all([
          api.get("/notifications").catch(() => []),
          api.get("/production-orders").catch(() => []),
          api.get("/shipments").catch(() => []),
        ]);
        handleNotificationsBatch(notifs || []);
        detectProdShipEvents((prods || []).length, (ships || []).length);
        detectProductionCompleted(prodListRef.current, prods || []);
        prodListRef.current = prods || [];
      } catch (e) { /* silent */ }
    };
    tick();
    const id = setInterval(tick, POLL_MS);
    return () => { stopped = true; clearInterval(id); };
  }, []);

  const toggle = async () => {
    const next = !enabled;
    setAlertsEnabled(next);
    setEnabled(next);
    if (next) {
      const p = await requestNotifPermission();
      setNotifPerm(p);
      playDing("info");  // izin verildiğini onayla
    }
  };
  const testSound = () => playDing("critical");

  return (
    <div className="flex items-center gap-1" data-testid="alert-toggle">
      <button onClick={toggle} title={enabled ? "Sesli/Bildirim uyarıları aktif — kapatmak için tıkla" : "Sesli/Bildirim uyarıları kapalı — açmak için tıkla"}
        className={`p-1.5 rounded transition ${enabled ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-400" : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-500"}`}
        data-testid="alert-toggle-btn">
        {enabled ? <Bell size={14}/> : <BellOff size={14}/>}
      </button>
      {enabled && (
        <button onClick={testSound} title="Sesi test et" className="p-1.5 rounded text-slate-500 hover:bg-slate-100 dark:hover:bg-slate-800" data-testid="alert-test-sound">
          <Volume2 size={14}/>
        </button>
      )}
      {enabled && notifPerm !== "granted" && notifPerm !== "unsupported" && (
        <span className="text-[10px] text-amber-600 dark:text-amber-400" title="Tarayıcı bildirim izni verilmedi — sadece ses çalar">⚠</span>
      )}
    </div>
  );
}
